import React, { useCallback, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../apis/api';

import { userContext } from '../App';

const Logout = () => {
    const history = useHistory();
    const {state,dispatch} = useContext(userContext);

    const logout = useCallback( async ()=>{
        if(state){
            try {
                await api.get('/logout');
                dispatch({type:"USER",payload:false});
                history.push('/products');
            } catch (error) {
                console.log(error);
            }
        }
    },[state,history,dispatch]);

    useEffect(()=>{
        logout();
    },[logout]);
    return (
        <>
            <h1>Successfully Loggedout</h1>
        </>
    )
}
export default Logout;
